module.exports = __webpack_public_path__ + "media/images/menu/rhea-8a369c77c829effb27c2459e226be929.jpg";